import React from "react";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import InsightsIcon from "@mui/icons-material/Insights";

const FeedbackPopup = ({
  isOpen,
  onClose,
  feedbackItems,
  percentage,
  aiEvalData,
  isAiEvalEnabled,
  isAdmin,
  onAiChipClick,
  onRegenerate,
  isRegenerating,
  isEvaluating,
}) => {
  if (!feedbackItems) return null;

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="feedback-modal-title"
      className="common-popup-overlay feedback-popup-overlay"
    >
      <div className="feedback-popup-container">
        <div className="feedback-popup-header">
          <div className="feedback-popup-title-box">
            <div className="feedback-popup-title" id="feedback-modal-title">
              Performance Analysis
            </div>
            <div className="feedback-popup-subtitle">
              You scored {percentage}% in this assessment.
            </div>
          </div>
          <IconButton
            onClick={onClose}
            className="feedback-popup-close-btn"
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        <div className="feedback-popup-content custom-scrollbar">
          {feedbackItems.length > 0 ? (
            feedbackItems.map((fb, index) => {
              const scoreColor =
                percentage < 50
                  ? "var(--feedback-needs-improvement)"
                  : percentage <= 75
                    ? "var(--feedback-good)"
                    : "var(--feedback-excellent)";
              const scoreBg =
                percentage < 50
                  ? "var(--feedback-needs-improvement-bg)"
                  : percentage <= 75
                    ? "var(--feedback-good-bg)"
                    : "var(--feedback-excellent-bg)";

              return (
                <div
                  key={index}
                  className="feedback-popup-item-section custom-scrollbar"
                >
                  <div className="feedback-popup-item-header">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <InsightsIcon
                        className="feedback-popup-section-icon"
                        style={{ color: scoreColor }}
                      />
                      <div
                        className="feedback-popup-section-title"
                        style={{ color: scoreColor }}
                      >
                        {fb.title || "Subject Feedback"}
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <div
                        className="feedback-popup-section-badge"
                        style={{ backgroundColor: scoreColor }}
                      >
                        {fb.performance_level}
                      </div>
                        {isAiEvalEnabled && !isAdmin && (
                          <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                            {isEvaluating || (isRegenerating && !aiEvalData) ? (
                              <button
                                className="ps-row__aieval-chip evaluated loading"
                                style={{ margin: 0, cursor: "default" }}
                                disabled
                              >
                                Evaluating...
                              </button>
                            ) : (
                              <button
                                className={`ps-row__aieval-chip ${aiEvalData ? 'evaluated' : ''}`}
                                onClick={onAiChipClick}
                                style={{ margin: 0 }}
                              >
                                {aiEvalData ? `Eval: ${aiEvalData.overall_score ?? aiEvalData.overall ?? 0}/10` : "Evaluate with AI"}
                              </button>
                            )}
                            {onRegenerate && (
                              <button
                                className={`ps-row__aieval-chip regenerate ${isRegenerating ? "loading" : ""}`}
                                onClick={onRegenerate}
                                disabled={isRegenerating}
                                style={{ margin: 0 }}
                                title="Regenerate with AI"
                              >
                                {isRegenerating ? "Regenerating..." : "Regenerate"}
                              </button>
                            )}
                          </div>
                        )}
                    </div>
                  </div>


                  <div className="feedback-card-body">
                    {fb.weak_topics && fb.weak_topics.length > 0 && (
                      <div className="feedback-section-item">
                        <div className="section-label">Areas to Focus On:</div>
                        <div className="topics-grid">
                          {fb.weak_topics.map((topic, topicIndex) => (
                            <span key={topicIndex} className="topic-tag">
                              {topic}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}

                    {fb.improvement_advice && (
                      <div className="feedback-section-item">
                        <div className="section-label">Recommendations:</div>
                        <div
                          className="advice-text"
                          style={{
                            borderLeft: `4px solid ${scoreColor}`,
                            backgroundColor: scoreBg,
                            color: scoreColor,
                            padding: "12px",
                            borderRadius: "8px",
                            fontWeight: 500,
                          }}
                        >
                          {fb.improvement_advice}
                        </div>
                      </div>
                    )}

                    {fb.content && (
                      <div className="feedback-section-item">
                        <div className="content-text">{fb.content}</div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="empty-feedback">
              <div>No detailed feedback currently available.</div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default FeedbackPopup;
